
import { mapState, mapGetters } from 'vuex';
import MileageNoticeHelper from '@/mixins/MileageNoticeHelper';

export default {
  name: 'AppTitleSection',
  mixins: [MileageNoticeHelper],
  data() {
    return {
      firstNotice: {},
      firstNoticeMessage: '',
      noticesCount: 0,
      isNoticeSummaryLoading: true
    };
  },
  computed: {
    ...mapState(['api']),
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('window', ['windowService']),
    ...mapGetters('review', ['displayNewReviewButton']),
    displayReviewsButton() {
      return (
        this.widget.use_reviews_button && this.reviewSettings.reviews_index_url
      );
    }
  },
  created() {
    this.loadNoticeSummary();
  },
  methods: {
    async loadNoticeSummary() {
      if (!this.widget.show_notices) return;

      this.isNoticeSummaryLoading = true;
      try {
        const [{ data }, mileageNotice] = await Promise.all([
          this.api.fetchNoticeSummary(),
          this.widget.show_mileage_notices
            ? this.fetchMileageNotice()
            : Promise.resolve(null)
        ]);

        if (mileageNotice) {
          this.firstNotice = mileageNotice;
          this.noticesCount = data.notices_count + 1;
        } else {
          this.firstNotice = data.first_notice;
          this.noticesCount = data.notices_count;
        }
      } finally {
        this.isNoticeSummaryLoading = false;
      }
    },
    onClickReviewsButton() {
      this.windowService.redirectTo(this.reviewSettings.reviews_index_url);
    }
  }
};
